import type { KnowledgeItem } from "@/components/admin_dashboard/knowledge-library/model";
import type { WorkflowKnowledge } from "@/lib/workflows/schema";

/** Owner-written items only. Websites and uploads never become instructions
 *  (the server applies the same rule in knowledge/precedence.ts). */
export const isPickableKnowledge = (item: KnowledgeItem) =>
  item.type === "note" || item.type === "faq" ||
  (item.type === "file" && !!item.isMarkdownFile && !item.hasOriginalFile);

/** Drops empty fields so a workflow with nothing set stores no `knowledge`. */
export function normalizeWorkflowKnowledge(next: WorkflowKnowledge): WorkflowKnowledge | undefined {
  const instructions = next.instructions ?? "";
  const sourceIds = next.sourceIds ?? [];
  if (!instructions.trim() && sourceIds.length === 0) return undefined;
  return {
    ...(instructions.trim() ? { instructions } : {}),
    ...(sourceIds.length ? { sourceIds } : {}),
  };
}
